import type { WidgetTheme } from '../types';

export const isAlternateTheme = (theme?: WidgetTheme): boolean => {
  return theme === 'bigben' || theme === 'liberty';
};
